import Timeout = NodeJS.Timeout;

const BASE_URL = process.env.REACT_APP_SERVER_URL || "http://localhost:8080/";

export async function get(path: string): Promise<any> {
    const response = await fetch(BASE_URL + path, {
        mode: "cors",
    });
    if (response.ok) {
        return await response.json();
    }
    throw Error(`Getting ${path} failed: ${response.statusText}`);
}

export async function post(path: string, data: any): Promise<void> {
    const response = await fetch(BASE_URL + path, {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(data),
        headers:{
            'Content-Type': 'application/json'
        }
    });
    if (response.ok) {
        return;
    }
    throw Error(`Posting ${path} failed: ${response.statusText}`);
}

export async function postWithResponse(path: string, data: any): Promise<any> {
    const response = await fetch(BASE_URL + path, {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(data),
        headers:{
            'Content-Type': 'application/json'
        }
    });
    if (response.ok) {
        return await response.json();
    }
    throw Error(`Posting ${path} failed: ${response.statusText}`);
}

const putRequests: Map<string, Timeout> = new Map();

export function put(path: string, data: any) {
    const oldRequest = putRequests.get(path);
    if (oldRequest) {
        clearTimeout(oldRequest);
    }
    const newRequest = setTimeout(
        async () => {
            putRequests.delete(path);
            const response = await fetch(BASE_URL + path, {
                method: "PUT",
                mode: "cors",
                body: JSON.stringify(data),
                headers:{
                    'Content-Type': 'application/json'
                }
            });
            if (response.ok) {
                return;
            }
            throw Error(`Putting ${path} failed: ${response.statusText}`);
        },
        100
    );

    putRequests.set(path, newRequest);
}

export async function putWithResponse(path: string, data: any): Promise<any> {
    const oldRequest = putRequests.get(path);
    if (oldRequest) {
        clearTimeout(oldRequest);
        putRequests.delete(path);
    }
    const response = await fetch(BASE_URL + path, {
        method: "PUT",
        mode: "cors",
        body: JSON.stringify(data),
        headers:{
            'Content-Type': 'application/json'
        }
    });
    if (response.ok) {
        return await response.json();
    }
    throw Error(`Putting ${path} failed: ${response.statusText}`);
}


export async function del(path: string, data?: any): Promise<void> {
    const response = await fetch(BASE_URL + path, {
        method: "DELETE",
        mode: "cors",
        body: JSON.stringify(data),
        headers:{
            'Content-Type': 'application/json'
        }
    });
    if (response.ok) {
        return;
    }
    throw Error(`Deleting ${path} failed: ${response.statusText}`);
}




// WEBPACK FOOTER //
// ./src/services/store-utils.ts